module.exports = __webpack_public_path__ + "static/img/solar-energy-02.6c82ed0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/solar-energy/solar-energy-02.jpg
// module id = 5Qdl
// module chunks = 99